// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Button, Toastr } from "../../../revvComponents";
import AddPricebookFields from "./AddPricebookFields";

import {
  addColumn,
  editPricebookColumn,
  getcrossViewOptionAction,
  updateCrossviewOption,
} from "../../../actions/PricebooksActions/pricebooksActions";
import CommonActions from "../../../actions/CommonActions";
import { GlobalUtils } from "../../../utils";

const TYPE_REVERSE_MAPPING = {
  dateColumn: "DateField",
  numberColumn: "Number",
  checkbox: "CheckBoxField",
  text: "Text",
  number: "Number",
  singleSelect: "Single Select",
  multiSelect: "Multi Select",
};
const { getColVisibility, updateColVisibility } = CommonActions;
const { readDataFromLocalStorage } = GlobalUtils;

// export default function AddProductColumn(props) {
class AddPriceBookcolumn extends Component {
  state = {
    title: "",
    description: "",
    fieldType: "",
    fieldTypeOptions: [{ id: 0, value: "" }],
    showColInQuoteTable: false,
    showColInPriceBook: false,
    hideColInProductCatalog: false,
    type: "",
    snapshotEnabled: false,
    errMsg: false,
  };

  componentDidMount() {
    if (this.props.isEditFlow) {
      const getAppView = readDataFromLocalStorage("appView");
      const { PricelistItemsView } =
        getAppView && getAppView.views ? getAppView.views : {};
      this.props
        .getcrossViewOptionAction(this.props.data.columnId, PricelistItemsView)
        .then(res => {
          if (res.columns.length > 0) {
            res.columns.forEach(item => {
              if (item.type === "LookUpColumn") {
                this.setState({ showColInPriceBook: true });
              }
              if (item.type === "SnapshotColumn") {
                this.setState({
                  showColInQuoteTable: true,
                  snapshotEnabled: true,
                });
              }
            });
          }
        });
      this.setState({
        title: this.props.data && this.props.data.headerName,
        hideColInProductCatalog:
          this.props.data.hidden !== undefined ? this.props.data.hidden : false,
        type: TYPE_REVERSE_MAPPING[this.props.data.type],
        fieldTypeOptions:
          this.props.data.props.values &&
          this.props.data.props.values.map((data, index) => ({
            id: index,
            value: data,
            isLocked: true,
          })),
      });
    }
  }

  _onInputChange = (name, value) => {
    this.setState(() => ({ [name]: value }));
  };

  _onSelectChange = value => {
    this.setState({
      type: value.value,
    });
  };

  _onToggleBoxChange = name => {
    this.setState(prevState => ({
      [name]: !prevState[name],
    }));
  };

  _onFieldTypeOptionAdd = () => {
    const obj = {
      id: this.state.fieldTypeOptions.slice(-1)[0].id + 1,
      value: "",
    };
    const updatedFieldTypeOptions = [...this.state.fieldTypeOptions, obj];

    this.setState(() => ({
      fieldTypeOptions: updatedFieldTypeOptions,
    }));
  };

  _onFieldTypeOptionChange = (value, id) => {
    const updatedFieldTypeOptions = this.state.fieldTypeOptions.map(obj =>
      obj.id === id ? { ...obj, value } : obj,
    );

    this.setState(() => ({
      fieldTypeOptions: updatedFieldTypeOptions,
      errMsg: false,
    }));
  };

  _onFieldTypeOptionRemove = id => {
    const updatedFieldTypeOptions = this.state.fieldTypeOptions.filter(
      obj => obj.id !== id,
    );

    this.setState(() => ({
      fieldTypeOptions: updatedFieldTypeOptions,
      errMsg: false,
    }));
  };

  _createAlias = text => text.trim().toLowerCase().split(" ").join("_");

  _getTypevalue = () => {
    switch (this.state.type) {
      case "Text":
        return "LongTextField";
      case "Number":
        return "NumericField";
      case "Single Select":
        return "SingleSelectField";
      case "Multi Select":
        return "MultiSelectField";
      default:
        return null;
    }
  };

  _handleSubmit = () => {
    const getAppView = readDataFromLocalStorage("appView");
    const { PricelistItemsView, DealTableView } =
      getAppView && getAppView.views ? getAppView.views : {};
    const fieldOptions = [];
    if (this.state.fieldTypeOptions && this.state.fieldTypeOptions.length > 0) {
      this.state.fieldTypeOptions.forEach(item =>
        fieldOptions.push(item.value),
      );
    }
    if (this.props.isEditFlow) {
      const payload = {
        field: {
          id: this.props.data.field,
          name: this._createAlias(this.state.title),
          type: this._getTypevalue(),
          props: {
            values: fieldOptions,
          },
          standard: this.props.data.standard,
        },
        editable: true,
        label: this.state.title,
        name: this._createAlias(this.state.title),
        type: "DirectColumn",
      };
      this.props
        .editPricebookColumn(
          payload,
          this.props.data.columnId,
          PricelistItemsView,
          this.props.pricelistId,
        )
        .then(() => {
          if (this.state.hideColInProductCatalog) {
            let managecolumn;
            this.props.getColVisibility("Pricelist").then(resp => {
              managecolumn = resp;
              const payloadCol = {};
              managecolumn.roles.forEach(role => {
                const columnStatus = {};
                managecolumn.data.forEach(list => {
                  if (list.id === this.props.data.columnId) {
                    columnStatus[list.id] = !this.state.hideColInProductCatalog;
                  } else {
                    columnStatus[list.id] = list.options[role.id].visible;
                  }
                });
                payloadCol[role.id] = columnStatus;
              });
              this.props
                .updateColVisibility(payloadCol, "Pricelist")
                .then(() => {});
            });
          }
          if (this.state.showColInQuoteTable && !this.state.snapshotEnabled) {
            const quotePayload = {
              column: {
                field: {
                  id: this.props.data.field,
                  name: `pricebook_${this._createAlias(this.state.title)}`,
                  type: this._getTypevalue(),
                  props: {
                    values: fieldOptions,
                  },
                  standard: this.props.data.standard,
                },
                editable: false,
                label: `Pricebook ${this.state.title}`,
                name: `pricebook_${this._createAlias(this.state.title)}`,
                type: "SnapshotColumn",
              },
              parent_column: {
                viewId: PricelistItemsView,
                id: this.props.data.columnId,
              },
            };
            this.props
              .updateCrossviewOption(quotePayload, DealTableView)
              .then(() => {});
          }
          Toastr.showToastr({
            type: "success",
            message: "Column is edited successful!",
            timeout: 2000,
          });
          this.props.onClose();
        })
        .catch(error => {
          console.error(
            `AddPriceBookcolumn => AddPriceBookcolumn => Error : ${error}`,
          );
          Toastr.showToastr({
            type: "failure",
            message: "Something went wrong. Please try again!",
            timeout: 3000,
          });
        });
    } else {
      const payload = {
        field: {
          name: this._createAlias(this.state.title),
          type: this._getTypevalue(),
          props: {
            values: fieldOptions,
          },
        },
        editable: true,
        label: this.state.title,
        name: this._createAlias(this.state.title),
        type: "DirectColumn",
      };
      this.props
        .addColumn(payload, this.props.pricelistId)
        .then(res => {
          if (this.state.hideColInProductCatalog) {
            let managecolumn;
            this.props.getColVisibility("Pricelist").then(resp => {
              managecolumn = resp;
              const payloadCol = {};
              managecolumn.roles.forEach(role => {
                const columnStatus = {};
                managecolumn.data.forEach(list => {
                  if (list.id === res.ViewColumn.id) {
                    columnStatus[list.id] = !this.state.hideColInProductCatalog;
                  } else {
                    columnStatus[list.id] = list.options[role.id].visible;
                  }
                });
                payloadCol[role.id] = columnStatus;
              });
              this.props
                .updateColVisibility(payloadCol, "Pricelist")
                .then(() => {});
            });
          }
          if (this.state.showColInQuoteTable) {
            const quotePayload = {
              column: {
                field: {
                  name: `pricebook_${this._createAlias(this.state.title)}`,
                  type: this._getTypevalue(),
                  props: {
                    values: fieldOptions,
                  },
                },
                editable: false,
                label: `Pricebook ${this.state.title}`,
                name: `pricebook_${this._createAlias(this.state.title)}`,
                type: "SnapshotColumn",
              },
              parent_column: {
                viewId: PricelistItemsView,
                id: res.ViewColumn.id,
              },
            };
            this.props
              .updateCrossviewOption(quotePayload, DealTableView)
              .then(() => {});
          }
          Toastr.showToastr({
            type: "success",
            message: "Column added successful!",
            timeout: 2000,
          });
          this.props.onClose();
        })
        .catch(error => {
          console.error(
            `AddPriceBookcolumn => AddPriceBookcolumn => Error : ${error}`,
          );
          Toastr.showToastr({
            type: "failure",
            message: "Something went wrong. Please try again!",
            timeout: 3000,
          });
        });
    }
  };

  _isProductColumnValid = () => {
    const { title, type, fieldTypeOptions } = this.state;
    let isDisabled = false;
    if (this.state.errMsg) {
      return true;
    }
    if (title === "" || type === "") {
      return true;
    }
    if ((type === "Single Select" || type === "Multi Select") && title !== "") {
      if (fieldTypeOptions.length >= 2) {
        for (let i = 0; i < fieldTypeOptions.length; i += 1) {
          let count = 0;
          const checkItem = fieldTypeOptions[i].value;
          for (let j = 0; j < fieldTypeOptions.length; j += 1) {
            if (fieldTypeOptions[j].value === checkItem) {
              count += 1;
            }
          }
          if (count >= 2) {
            this.setState({
              errMsg: true,
            });
            return true;
          }
        }
      }
      fieldTypeOptions.forEach(item => {
        if (item.value !== "") {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
      });
      return isDisabled;
    }

    return isDisabled;
  };

  render() {
    return (
      <React.Fragment>
        <div className="addproductcolumn-wrapper">
          <div className="addproductcolumn-righpane-wrapper">
            <div className="addproductcolumn-righpane-section">
              <div className="addproductcolumn-header">
                <div>
                  <Button
                    className="addproductcolumn-add-btn"
                    data-test="addproductcolumn-add-btn"
                    onClick={this.props.onClose}>
                    <i>
                      <FontAwesomeIcon icon={["far", "angle-left"]} />
                    </i>
                    {this.props.isEditFlow ? "Edit column" : "Add new column"}
                  </Button>
                </div>

                <div>
                  <Button
                    className="addproductcolumn-discard-btn btn-transparent"
                    data-test="addproductcolumn-discard-btn"
                    onClick={this.props.onClose}>
                    Discard
                  </Button>
                  <Button
                    disabled={this._isProductColumnValid()}
                    className="addproductcolumn-save-btn"
                    data-test="addproductcolumn-save-btn"
                    onClick={this._handleSubmit}
                    onKeyDown={() => {}}>
                    {this.props.isEditFlow ? "Update column" : "Save column"}
                  </Button>
                </div>
              </div>
              <div>
                <AddPricebookFields
                  title={this.state.title}
                  type={this.state.type}
                  description={this.state.description}
                  fieldType={this.state.fieldType}
                  hideColInProductCatalog={this.state.hideColInProductCatalog}
                  showColInQuoteTable={this.state.showColInQuoteTable}
                  onInputChange={this._onInputChange}
                  onSelectChange={this._onSelectChange}
                  onToggleBoxChange={this._onToggleBoxChange}
                  fieldTypeOptions={this.state.fieldTypeOptions}
                  onFieldTypeOptionRemove={this._onFieldTypeOptionRemove}
                  onFieldTypeOptionChange={this._onFieldTypeOptionChange}
                  onFieldTypeOptionAdd={this._onFieldTypeOptionAdd}
                  errMsg={this.state.errMsg}
                  {...this.props}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  addColumn,
  editPricebookColumn,
  getColVisibility,
  updateColVisibility,
  getcrossViewOptionAction,
  updateCrossviewOption,
};

export default connect(null, mapDispatchToProps)(AddPriceBookcolumn);
